"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/web.dom.iterable");


















































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {var _this = this;return { loading: true, tableData: [], // 列表数据
      droplist: [], typeList: [{ 'key': '1', 'value': '固定程序' }, { 'key': '2', 'value': '自定义程序' }, { 'key': '3', 'value': '组合程序' }, { 'key': '4', 'value': '高级按摩' }], newadd: false, newadd2: false, urlName: '', title: '', searchData: { sn: '', status: '', type: '', deviceType: '', userId: '', appid: '', startTime: '', // startTime: datesFormatter(new Date() - 3600 * 1000 * 24 * 30),
        endTime: '', // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'userId', label: '用户Id', isShow: true }, { prop: 'appid', label: 'appId', isShow: true }, { prop: 'sn', label: 'sn', isShow: true }, { prop: 'operationName', label: '操作名称', isShow: true }, { prop: 'type', label: '程序类型', formatter: function formatter(row, column, val) {var self = _this;var result = '';self.typeList.forEach(function (element) {if (val === element.key) {result = element.value;}});return result;}, isShow: true }, { prop: 'uuid', label: '程序UUID', isShow: false }, { prop: 'programName', label: '程序名称', isShow: true }, { prop: 'deviceType', label: '设备类型', isShow: true }, { prop: 'version', label: '中心版本', isShow: false }, { prop: 'program', label: '程序命令', isShow: false }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }] };}, mounted: function mounted() {var self = this;self.init();self.getdrop();}, methods: { init: function init() {var self = this;self.loading = true;var path = '/api/ck/event/advancedMassageEvent';self.getData(path, self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;
        self.loading = false;
      });
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.droplist = res;
      });
    },
    checkPermission: _user.checkPermission,
    resetFun: function resetFun() {// 重置
      this.searchData.userId = '';
      this.searchData.appid = '';
      this.searchData.sn = '';
      this.searchData.deviceType = '';
      this.searchData.startTime = '';
      this.searchData.endTime = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    }
    // excelFun: function() {
    //   const self = this
    //   var day_30 = 3600 * 30 * 24 * 1000
    //   // 校验时间是否填写
    //   if (self.searchData.startTime === '') {
    //     self.$message({
    //       message: '请选择开始时间',
    //       type: 'error'
    //     })
    //     return false
    //   } else if (self.searchData.endTime === '') {
    //     self.$message({
    //       message: '请选择结束时间',
    //       type: 'error'
    //     })
    //     return false
    //   } else if ((self.searchData.endTime - self.searchData.startTime) > day_30) {
    //     self.$message({
    //       message: '只能导出小于等于30天的的时间',
    //       type: 'error'
    //     })
    //     return false
    //   }
    //   if (this.searchData.endTime) {
    //     var endTime = this.searchData.endTime
    //     if (endTime.split(' ').length < 2) {
    //       endTime = endTime + ' 23:59:59'
    //       this.searchData.endTime = endTime
    //     }
    //   }
    //   if (this.searchData.startTime) {
    //     var startTime = this.searchData.startTime
    //     if (startTime.split(' ').length < 2) {
    //       startTime = startTime + ' 00:00:00'
    //       this.searchData.startTime = startTime
    //     }
    //   }
    //   self.getData('/api/event/export/check', self.searchData, function(res) {
    //     if (res == null) {
    //       window.location.href = '/api/event/export/ec0014?startTime=' +
    //         self.searchData.startTime + '&endTime=' + self.searchData.endTime + '&userId=' +
    //         self.searchData.userId + '&appid=' + self.searchData.appid + '&deviceType=' +
    //         self.searchData.deviceType + '&sn=' + self.searchData.sn
    //     }
    //   })
    // }
  } };exports.default = _default;